import React from 'react';

import { Connect } from '@rover/react-lib/src/components/utils/Redux';
import AdvancedFiltersCollectionV2 from '@rover/react-lib/src/pages/search/SearchPage/components/Filters/Collections/AdvancedFiltersCollectionV2';
import { selectors as searchPageSelectors } from '@rover/react-lib/src/pages/search/SearchPage/SearchPage.duck';
import { selectors as frontendConfigurationSelectors } from '@rover/react-lib/src/redux/ducks/frontendConfiguration.duck';
import { selectors as searchSelectors } from '@rover/react-lib/src/redux/ducks/search.duck';
import { selectors as serviceTypeSelectors } from '@rover/react-lib/src/redux/ducks/serviceTypes.duck';
import type { SearchFilters } from '@rover/types/src/SearchFilters';

import { selectors as searchFiltersSelectors } from '../../../SearchFilters.duck';

export type Props = {
  formData: Partial<SearchFilters>;
  onChange: (arg0: Partial<SearchFilters>) => void;
};

const selector = (state) => ({
  getServiceTypeBySlug: serviceTypeSelectors.getServiceTypeBySlug(state),
  currencyCode: searchSelectors.getSearchCurrencyCode(state),
  getPriceUnit: serviceTypeSelectors.getPriceUnit(state),
  hasPets: searchSelectors.getHasPets(state),
  language: frontendConfigurationSelectors.getLanguage(state),
  petSizeBuckets: searchSelectors.getSearchDogSizeBuckets(state),
  priceFilterMaxValue: searchPageSelectors.getPriceFilterMaxValue(state),
  priceFilterMinValue: searchPageSelectors.getPriceFilterMinValue(state),
  searchFilters: searchFiltersSelectors.getFilters(state),
  serviceTypeFilterOptions: searchFiltersSelectors.getServiceTypeFilterOptions(state),
  weightUnit: searchSelectors.getSearchWeightUnit(state),
  serviceTypeSelectors: serviceTypeSelectors.getServiceTypeBySlug(state),
  queryDerivedData: searchSelectors.getQueryDerivedData(state),
  priceTransparencyLevel: searchSelectors.getPriceTransparencyLevel(state),
  cardTreatment: searchSelectors.getCardTreatment(state),
});

const AdvancedFiltersCollectionContainer = (props: Props): JSX.Element => (
  <Connect selector={selector}>
    {(connectedProps) => <AdvancedFiltersCollectionV2 {...connectedProps} {...props} />}
  </Connect>
);

export default AdvancedFiltersCollectionContainer;
